import { render } from "./MenuSidebarPearlAI.vue?vue&type=template&id=b03dde40&scoped=true&lang=html"
import script from "./MenuSidebarPearlAI.vue?vue&type=script&lang=js"
export * from "./MenuSidebarPearlAI.vue?vue&type=script&lang=js"

import "./MenuSidebarPearlAI.vue?vue&type=style&index=0&id=b03dde40&lang=css&scoped=true"

import exportComponent from "/Users/numeria/Desktop/innopearl-partner-plus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03dde40"]])

export default __exports__